import { PayloadServiceGroup, PayloadServiceGroupGeneration } from '../../payload/payload-types.zod'
import { z } from 'zod'

// Allowlist FE-facing fields. Picking (not extending the full Payload type)
// keeps BE-only fields — validationPrompt (the AI prompt), _order (Payload's
// internal sort key) and active (always true post-filter) — from leaking.
export const ServiceGroupWithGenerationResponseSchema = PayloadServiceGroup.pick({
  id: true,
  title: true,
  description: true,
  showMunicipalityLinks: true,
  links: true,
  updatedAt: true,
  createdAt: true,
}).extend({
  // services' BE-only fields (active, validationPrompt) live inside the array
  // elements, so .pick() can't reach them — re-declare with FE fields only.
  services: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      description: z.string(),
    }),
  ),
  generation: PayloadServiceGroupGeneration.omit({
    individual: true,
    serviceGroup: true,
  }).optional(),
})

export type ServiceGroupGeneration = z.infer<typeof PayloadServiceGroupGeneration>
export type ServiceGroupDb = z.infer<typeof PayloadServiceGroup>
export type ServiceGroupGenerationDb = z.infer<typeof PayloadServiceGroupGeneration>

export function serviceGroupWithGenerationToResponse(
  serviceGroup: ServiceGroupDb,
  generation?: ServiceGroupGenerationDb,
): ServiceGroupWithGenerationResponse {
  return ServiceGroupWithGenerationResponseSchema.parse({
    ...serviceGroup,
    generation,
  } satisfies ServiceGroupWithGenerationResponse)
}

export type ServiceGroupWithGenerationResponse = z.infer<
  typeof ServiceGroupWithGenerationResponseSchema
>
